// extracted by mini-css-extract-plugin
export var copyButton = "CopyLink-module_copyButton__17S1D";